import { Injectable } from '@angular/core';
import { BaseWorkflowStateService } from '../base-workflow-state.service';
import { InstallationSchedulingData } from '../../../../../../models/order/workflow/installation-scheduling.model';


@Injectable({ providedIn: 'root' })
export class InstallationSchedulingStateService extends BaseWorkflowStateService<InstallationSchedulingData> {
    override stateKey: string = 'installationScheduling';
}